<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount">
            <div style="position: relative">
              <AmountSelector />
              <ErrorLabel field="amount" style="text-align: right" />
            </div>
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addMonthly addSplit/>
            </div>
          </FormSection>
          <FormSection title="Donation Designation" v-if="form.applications[0].department == 'NCSY_AtlanticSeaboard'">
            <FormRow class="designation" inline>
              <FormSelect field="applications.0.campaign">
                <option selected="selected" value="General Donation">General Donation</option>
                <option value="Summer Scholarship"> Scholarship</option>
                <option value="Concert">Concert</option>
                <option value="Greater Washington Dinner">Greater Washington Dinner</option>
                <option value="Summer Scholarship">Summer Scholarship</option>
                <option value="Gap Year/Israel Scholarship">Israel Scholarship</option>
                <option value="JSU Expansion">JSU Expansion</option>
              </FormSelect>
              <ErrorLabel field="applications.0.campaign" style="text-align: right" />
            </FormRow>
          </FormSection>
          <FormSection title="Donation Designation" v-if="form.applications[0].department == 'NCSY_CentralEast'">
            <FormRow class="designation" inline>
              <FormSelect field="applications.0.campaign">
                <option selected="selected" value="General Donation">General Donation</option>
                <option value="Cincinnati Donation"> Cincinnati Donation</option>
                <option value="Columbus Donation"> Columbus Donation</option>
                <option value="Cleveland Donation"> Cleveland Donation</option>
                <option value="Detroit Donation"> Detroit Donation</option>
                <option value="Pittsburgh Donation"> Pittsburgh Donation</option>
                <option value="Toledo Donation"> Toledo Donation</option>        
                <option value="JSU Expansion">JSU Expansion</option>
              </FormSelect>
              <ErrorLabel field="applications.0.campaign" style="text-align: right" />
            </FormRow>
          </FormSection>
          <FormSection title="Donation Designation" v-if="form.applications[0].department == 'NCSY_Midwest'">
            <FormRow class="designation" inline>
              <FormSelect field="applications.0.campaign">
                  <option selected="selected" value="General Donation">General Donation</option>
                  <option value="End of Year">End of Year</option>
                  <option value="Fighting Antisemitism">Fighting Antisemitism</option>
                  <option value="Relief Mission">Relief Mission</option>
                  <option value="IMO Bella Smith">Bella Smith Fund</option>
                <option value="Shabbaton Scholarship">Shabbatons</option>
                  <option value="TJJ">TJJ</option>
                  <option value="Rosh Hashana">Rosh Hashana/Yom Kippur</option>
                  <option value="Purim Donation">Purim Donation</option>
                  <option value="Alumni Society">Alumni Society</option>
                  <option value="Manny Gold A'H Fund">Manny Gold A"H Fund</option>
                  <option value="Torah Fund">Torah Fund</option>
                  <option value="Scholarships">Scholarship Fund</option>
                  <option value="Post HS Israel">Post High School Israel Scholarship Fund</option>
                  <option value="Banquet">Banquet Pledge</option>
                  <option value="Tammy Kaplan">Tammy Kaplan A'H Scholarship Fund</option>
                  <option value="Scholarships">Emanuel and Anita Margulis Scholarship Fund</option>
                  <option value="JSU Expansion">JSU Expansion</option>
              </FormSelect>
              <ErrorLabel field="applications.0.campaign" style="text-align: right" />
            </FormRow>
          </FormSection>
          <FormSection title="Donation Designation" v-if="form.applications[0].department == 'NCSY_Seattle'">
            <FormRow class="designation" inline>
              <FormSelect field="applications.0.campaign">
              <option selected="selected" value="General Donation">General Donation</option>
              <option value="JSU Donation">JSU Club Donation</option>
              <option value="Challenge Grant">Challenge Grant</option>
              <option value="Summer Scholarship">Summer Scholarship</option>
              <option value="Seattle Fundraising Event">Seattle Fundraising Event</option>     
              <option value="JSU Expansion">JSU Expansion</option> 
              </FormSelect>
              <ErrorLabel field="applications.0.campaign" style="text-align: right" />
            </FormRow>
          </FormSection>
          <FormSection title="Donation Designation" v-if="form.applications[0].department == 'NCSY_Southwest'">
            <FormRow class="designation" inline>
              <FormSelect field="applications.0.campaign">
              <option selected="selected" value="General Donation">General Donation</option>
              <option value="Boulder Donation">Boulder NCSY</option><option value="Dallas Donation">Dallas NCSY</option><option value="Denver Donation">Denver NCSY</option><option value="Houston Donation">Houston NCSY</option><option value="San Antonio Donation">San Antonio NCSY</option>            
              <option value="JSU Expansion">JSU Expansion</option>
                
              </FormSelect>
              <ErrorLabel field="applications.0.campaign" style="text-align: right" />
            </FormRow>
          </FormSection>
          <FormSection title="Donation Designation" v-if="form.applications[0].department == 'NCSY_Southern'">
            <FormRow class="designation" inline>
              <FormSelect field="applications.0.campaign">
                <option selected="selected" value="General Donation">General Donation</option>
                <option value="Chanukah Appeal">Channukah Challenge</option>
                <option value="Israel Scholarship">Gap Year Scholarship</option>
                <option value="Hate Ends Now">Hate Ends Now</option>
                <option value="Israel Advocacy">Israel Advocacy</option>
                <option value="JSU Donation">JSU Clubs</option>
                <option value="JSU Give Back">JSU Give Back</option>
                <option value="Mentorships">Mentorships</option>
                <option value="La Casa">LaCasa</option>
                <option value="Scholarship Donation">Regional Convention Scholarship</option>
                <option value="Summer Scholarship">Summer Program Scholarship</option>
                <option value="TJJ Bus">Support a TJJ Bus with Bernie Marcus and Mike Leven</option>
                <option value="TJJ Donation">TJJ Scholarships</option>
                <option value="Young Professionals Event">Young Professionals Night Out</option> 
                <option value="JSU Expansion">JSU Expansion</option>
              </FormSelect>
              <ErrorLabel field="applications.0.campaign" style="text-align: right" />
            </FormRow>
          </FormSection>          
          <FormSection title="Notes">
            <FormRow>
              <FormInput type="textarea" class="width-half" field="custom.Notes" />
            </FormRow>
          </FormSection>
          <FormSection>
            <InHonorOf />
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>       
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate Now" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  setup() {
    const { setValue, form, getValue } = usePaymentForm();

    
      const params = queryParams()

      if (params.type && params.type === 'split') {
      setValue("dayOfMonth", null);
      setValue("periodMonths", "2");
      }
  
    
    return {
      form,
      getValue,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;
}
::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #1aa8d3;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
}

::v-deep .styled-radio--ou-donation.styled-radio .radio-part {
  @media (min-width: 720px) {
    min-width: 33.3%;
    flex: 1;
    max-width: 33.3%;
  }
}

.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}

::v-deep .styled-radio-container--ou-donation.styled-radio-container .radio-part{
  @media (min-width: 720px) {
  min-width: 25%;
    max-width: 25%;
  }
}
</style>
